import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby'
import { OmButton } from '@om/component-library-react';
import { ThemeContext } from '../context/ThemeContext';
import './ActionButton.scss';

const ActionButton = ({
    actionButtonContent
}) => {
    if (!actionButtonContent) {
        return '';
    }

    const theme = React.useContext(ThemeContext);

    const { has_boundary,
        heading_text,
        sub_heading_text,
        action_button_text,
        action_button_type
    } = actionButtonContent;

    return (
        <section>
            <div className={`${theme} om-section`} style={{ textAlign: "center",  marginTop: '0px', paddingTop: '0px' }}>
                {has_boundary ? <div class="boundary-line-wrapper"><hr style={{ marginBottom: "0px" }} /></div> : null}
            </div>
            <div class={`om-action-button-container`} style={{ textAlign: "center",  marginTop: '0px', paddingTop: '0px' }}>
                <om-section>
                    <div slot="section" style={{ textAlign: 'center', marginTop: '0px', paddingTop: '0px !important' }}>
                        <p class="action-button-heading">{heading_text}</p>
                        <p class="action-button-subheading">{sub_heading_text}</p>
                        <div className='action-button-button' style={{ marginTop: '0px', paddingTop: '0px' }}>
                            {action_button_text ?
                                <OmButton
                                    type="primary"
                                    size="large"
                                    text={action_button_text}
                                    actionType={action_button_type}
                                    iconName="arrow_forward"
                                    withIcon="true"
                                />
                                : null}
                        </div>
                    </div>
                </om-section>
            </div>
        </section>
    );
};

export const pageQuery = graphql`
fragment ActionButton on Contentstack_action_button {
    uid
    has_boundary
    heading_text
    sub_heading_text
    action_button_text
    action_button_type
  }
`;

export default ActionButton;
